import { Service } from '@roc/feature-app-core';

const url = {
  GET_ENTITY_BANK_INFO: '/api/v1/document/formDocument/getTitleCompanyBankInfo',
  GET_ENTITY_BANK_INFO_FOR_LENDER: '/api/v1/document/formDocument/getTitleCompanyBankInfoForLender',
  UPDATE_ENTITY_BANK_INFO:
    '/api/v1/document/formDocument/updateTitleCompanyBankInfo',
  UPDATE_ENTITY_BANK_INFO_LENDER_ENTITY:
    '/api/v1/document/formDocument/updateTitleCompanyBankInfoLenderEntity',
  REJECT_ENTITY_BANK_INFO: '/api/v1/loan/rejectBankInformationByEntity',
  APPROVE_ENTITY_BANK_INFO: '/api/v1/loan/approveEntityBankInformation',
  SEND_WIRE_INSTRUCTIONS_REQUEST: '/api/v1/vendor/wire/sendRequest',
  UPDATE_TITLE_COMPANY_BANK_INFO: '/api/v1/document/formDocument/updateTitleCompanyBankInfo',
  GET_TASK_DOCUMENTS: '/api/v1/taskV2/taskDocuments/findByTaskId',
  DOWNLOAD_WIRE_INSTRUCTIONS_DOCUMENT: '/api/v1/taskV2/taskDocuments/downloadByTaskId',
};

export class TitleCompanyBankInformationService extends Service {
  url;
  constructor() {
    super();
    this.url = url;
  }
  getTitleCompanyBankInfo(loanId: string) {
    return this.get(this.url.GET_ENTITY_BANK_INFO, { loanId });
  }
  getTitleCompanyBankInfoForLender(companyId: string) {
    return this.get(this.url.GET_ENTITY_BANK_INFO_FOR_LENDER, { companyId });
  }
  updateTitleCompanyBankInfo(loanId, payload) {
    return this.post(
      `${this.url.UPDATE_ENTITY_BANK_INFO}?loanId=${loanId}`,
      payload
    );
  }
  updateTitleCompanyBankInfoLenderEntity(loanId, payload) {
    return this.post(
      `${this.url.UPDATE_ENTITY_BANK_INFO_LENDER_ENTITY}?companyId=${loanId}`,
      payload
    );
  }

  rejectEntityBankInformation(loanId, entityType, rejectReason) {
    return this.get(this.url.REJECT_ENTITY_BANK_INFO, { entityId: loanId, entityType, reason: rejectReason });
  }

  approveEntityBankInformation(loanId, entityType) {
    return this.get(this.url.APPROVE_ENTITY_BANK_INFO, { entityId: loanId, entityType });
  }

  sendWireInstructionsRequest(loanId: number) {
    return this.post(`${this.url.SEND_WIRE_INSTRUCTIONS_REQUEST}?loanId=${loanId}`, {});
  }

  updateWireInformation(loanId: number, data: string) {
    return this.post(
      `${this.url.UPDATE_TITLE_COMPANY_BANK_INFO}?loanId=${loanId}`,
      data,
      { 'Content-Type': 'application/json' }
    );
  }

  getTaskDocuments(taskId: number) {
    return this.get(this.url.GET_TASK_DOCUMENTS, { taskId });
  }

  downloadWireInstructionsDocument(taskId: number) {
    return this.get(this.url.DOWNLOAD_WIRE_INSTRUCTIONS_DOCUMENT, { taskId });
  }
}
